import axios from 'axios';

// Fetch a random fact from the API
// The API returns a fact in the following format:
// {
//   "id": 1,
//   "text": "A cat has 32 muscles in each ear.",
//   "source_url": "https://cat-fact.herokuapp.com/facts/1",
//   "language": "en",
//   "permalink": "https://uselessfacts.jsph.pl/1",
//   "created_at": "2019-01-05T13:20:01.000Z",
//   "updated_at": "2019-01-05T13:20:01.000Z"
// }
export const fetchRandomFact = () => {
  // Fetch a random fact from the API
  return axios.get(
    // Using CORS proxy
    'https://cors-anywhere-3916.herokuapp.com/https://uselessfacts.jsph.pl/api/v2/facts/random?language=en',
    {
      transformResponse: [
        function (data) {
          // Parse the response data
          const parsedData = JSON.parse(data);
          const { text: fact, source_url: sourceUrl } = parsedData;
          return {
            // Return a more readable object
            fact,
            sourceUrl,
          };
        },
      ],
    }
  );
};

export default {
  fetchRandomFact,
};
